import { v2 } from '@saucelabs/sl-module-builds';
import { CURRENT_DC } from '@saucelabs/sl-util-config';
import { utils as authUtils } from '@saucelabs/sl-container-authentication';
import { push as historyPush } from 'connected-react-router';

import * as selectors from './selectors';
import { NAMESPACE } from './types';
import {
  operations as rootCauseOperations,
  actions as rootCauseActions,
} from '../root-causes';
import actions from './actions';

const META = { skipErrorPage: true };
export const vdcCommonOperations = v2.buildsDetail.operations.createVDCOperations(
  NAMESPACE,
  selectors,
);
export const vdcListOperations = v2.buildsList.operations.createVDCOperations(
  NAMESPACE,
  selectors,
);
export const vdcOpenSourceCommonOperations = v2.buildsDetail.operations
  .createVDCOperations(NAMESPACE, selectors, true);
export const vdcOpenSourceListOperations = v2.buildsList.operations
  .createVDCOperations(NAMESPACE, selectors, true);

export const initialize = (params, meta = META) => (dispatch, getState) => {
  const isOpenSource = !!params?.username;
  const commonOperations = isOpenSource ? vdcOpenSourceCommonOperations : vdcCommonOperations;
  return dispatch(commonOperations.initialize(params, meta))
    .then(() => (
      // Failure Analysis is disabled on headless (us-east-1)
      selectors.isInitialized(getState()) && CURRENT_DC !== 'us-east-1' ?
        dispatch(rootCauseOperations.getContribution()) :
        Promise.resolve()
    )).catch(() => {
      const {
        isAuthenticated,
        currentPathname,
      } = selectors.authCheckSelector(getState(), { isOpenSource });
      if (!isAuthenticated) {
        throw authUtils.redirectToMainLogin(currentPathname);
      }
    });
};

export const cleanup = () => (dispatch) => (
  Promise.all([
    dispatch(actions.cleanup()),
    dispatch(rootCauseActions.cleanup()),
  ])
);

export const changeTab = ({ url, tabName }) => (dispatch) => {
  const newTabName = tabName ? `/${tabName}` : '';
  return dispatch(historyPush(`${url.replace(/\/root-causes/, '')}${newTabName}`));
};
